import gql from 'graphql-tag';

const GET_VALIDATE_TAG_DOMAIN = gql`
  query getTagsComparisonObject($url: String!) {
    getTagsComparisonObject(input: { url: $url }) {
      isValid
      status
      msg
    }
  }
`;

export default GET_VALIDATE_TAG_DOMAIN;
